"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userMessagesController = function () {
  function userMessagesController(UsersService, AuthService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, userMessagesController);
    this.usersService = UsersService;
    this.authService = AuthService;
  }

  (0, _createClass3.default)(userMessagesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.usersService.getMessagesDataSource(this.userId, true, function () {}, this.dataSourceErrorSuccessCallback),
        sortable: true,
        pageable: true,
        resizable: true,
        noRecords: {
          template: "No Messages."
        },
        columns: [{ field: "creationDate", title: "Date", filterable: false, width: "2.5rem", template: "#= kendo.toString(new Date(creationDate), 'dd/MM @ hh:mmtt') #" }, { field: "messageType", title: "Type", filterable: false, width: "1rem", template: function template(dataItem) {
            return dataItem.messageType == 1 ? "Email" : dataItem.messageType == 2 ? "SMS" : "Push";
          } }, { field: "destination", title: "Target", filterable: false, width: "2rem" }, { field: "title", title: "Title", filterable: false, width: "3rem" }, { field: "body", title: "Body", filterable: false, width: "8rem" }, { field: "notificationOutcome", title: "Notification Outcome", filterable: false, sortable: false, width: "3rem", template: function template(dataItem) {
            return "" + _this.getNotificationOutcome(dataItem);
          } }]
      };
    }
  }, {
    key: "getNotificationOutcome",
    value: function getNotificationOutcome(dataItem) {
      if (dataItem.messageType !== 3) return "";

      var outcome = "";

      switch (dataItem.notificationOutcome) {
        case _constants2.default.notificationOutcome.QUEUED:
          outcome += "N/A";
          break;
        case _constants2.default.notificationOutcome.PROCESSING:
          outcome += "Processing";
          break;
        case _constants2.default.notificationOutcome.COMPLETED:
          outcome += "Completed";
          break;
        case _constants2.default.notificationOutcome.ABANDONED:
          outcome += "Abandoned";
          break;
        case _constants2.default.notificationOutcome.UNKNOWN:
          outcome += "Unknown";
          break;
        case _constants2.default.notificationOutcome.NOTARGETFOUND:
          outcome += "No Target Found";
          break;
        case _constants2.default.notificationOutcome.CANCELLED:
          outcome += "Cancelled";
          break;
        default:
          outcome += '';
          break;
      }

      if (dataItem.notes) {
        outcome += ' - ' + dataItem.notes;
      }

      return outcome;
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }]);
  return userMessagesController;
}();

exports.default = userMessagesController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-messages/user-messages.controller.js
 **/